/** @jsx jsx */
import React from 'react';
import { jsx } from '@emotion/core'; 
import HourInput from 'components/atoms/Form/HourInput';
import { SalarySupportStaff } from 'domain/master/general/salaryDataStaff';
import { useOrganizationSupportEdit } from './hooks';
import { SubActionButton } from 'components/atoms/Button';

const OrganizationSupportEdit: React.FC<{
  isShowHourlyWageAddition: boolean,
  support: SalarySupportStaff;
  setSupport: (manager: SalarySupportStaff) => void;
  deleteSupport: () => void;
}> = ({
  isShowHourlyWageAddition, support, deleteSupport, setSupport,
}) => {
    const {
      addHourSalary,
      supportTransportation,
      changeAddHourlySalary,
      changeSupportTransportation,
    } = useOrganizationSupportEdit(support, setSupport);
    return (
      <tr>
        <td style={{ textAlign: 'center' }}>
          <SubActionButton action={1} text="削除" onClick={deleteSupport} />
        </td>
        <td>{support.orgName}</td>
        <td>
          {
            isShowHourlyWageAddition && (
              <HourInput
                name="addHourlySalary"
                value={addHourSalary}
                label="円"
                onChange={(e) => {
                  changeAddHourlySalary(Number(e.target.value));
                }}
                min={0}
                max={99999999}
              />
            )
          }
        </td>
        <td>
          <HourInput
            name="supportTransportation"
            value={supportTransportation}
            label="円"
            onChange={(e) => {
              changeSupportTransportation(Number(e.target.value));
            }}
            min={0}
            max={99999999}
          />
        </td>
      </tr>

    );
  };

export default OrganizationSupportEdit;
